var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ob-client-section',{attrs:{"type":"municipiiClient","label":"Header_2"}})
}
var staticRenderFns = []

export { render, staticRenderFns }